import React, { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { Box, Typography } from '@vp/swan';
import { usePriceContext } from 'src/hooks/PriceContextHooks';
import { useProductContext } from 'src/hooks/ProductContextHooks';
import { PriceDisplay } from './PriceDisplay';

export type PricingInformationProps = {
  isMobile: boolean;
};

const PricingInformation = ({ isMobile }: PricingInformationProps): ReactElement => {
  const { price } = usePriceContext();
  const { productInformation } = useProductContext();

  return (
    <>
      {price && (
        <Box marginTop={isMobile ? '5' : '7'} style={{ whiteSpace: 'normal' }}>
          <Typography
            fontWeight="bold"
            fontSize={isMobile ? 'xsmall' : 'small'}
            style={{ display: 'inline-block' }}
            marginRight={'3'}
          >
            <Trans i18nKey="starting-at-price" values={{ quantity: productInformation.quantity }}>
              Starting at <PriceDisplay price={price} priceIsLoaded />
            </Trans>
          </Typography>
        </Box>
      )}
    </>
  );
};

export default PricingInformation;
